import * as React from "react";
import styled from "styled-components";

interface TitleBlockProps {
  /** ID ZEWNĘTRZEGO KOMPONENTU => DO NAWIGACJI */
  id?: string

  /** PIERWSZA LINIA => CZARNY TEXT */
  firstLineBlackStart: string

  /** PIERWSZA LINIA => NIEBIESKI TEXT */
  firstLineBlue: string

  /** PIERWSZA LINIA => CZARNY TEXT */
  firstLineBlackEnd: string

  /** DRUGA LINIA => TEXT */
  secondLineText: string | string[]

  /** PADDING TOP => OVERRIDE DEFAULT 55PX */
  paddingTop?: number

  /** PADDING BOTTOM => OVERRIDE DEFAULT 55PX */
  paddingBottom?: number

  /** NAGŁÓWEK JAKO H1 => GDY TO GŁÓWNY TYTUŁ STRONY (DOMYŚLNIE H2) */
  isPageTitle?: boolean
}

const TitleBlock = (props: TitleBlockProps) => {
  const {firstLineBlackStart,firstLineBlue,firstLineBlackEnd,secondLineText,paddingTop,paddingBottom,isPageTitle} = props;

  // H1 ALBO H2 => TA SAMA KLASA I WYGLĄD
  const HeaderTag: any = isPageTitle ? "h1" : "h2";

  // SPRAWDZANIE CZY DRUGA LINIA JEST ARRAY
  const secondLineTextIsAList: boolean = Array.isArray(secondLineText);

  // ZWRACANIE DANYCH
  return (
    <div className="goodgrowth-theme-styles">
      <TitleBlockIdWrapper id={props.id}/>
      <TitleBlockWrapper className="introtext" paddingTop={paddingTop} paddingBottom={paddingBottom}>
        <div className="row">
          <div className="col-sm-12">
            <HeaderTag className="title-block-header">{firstLineBlackStart} <span>{firstLineBlue}</span> {firstLineBlackEnd}</HeaderTag>
            {!secondLineTextIsAList && <p className="text-center">{secondLineText}</p>}
            {secondLineTextIsAList && (secondLineText as string[]).map((secondLineTextLine: string, i: number) => <p key={i} className="text-center">{secondLineTextLine}</p>)}
          </div>
        </div>
      </TitleBlockWrapper>
    </div>
  )
};

/** STYLES */

const TitleBlockWrapper: any = styled.section`
  .title-block-header {
    font-family: 'Raleway' !important;
  }
  /* H1 => WYGLĄD JAK H2 Z MOTYWU (ROZMIAR I ODSTĘP POD SPODEM) */
  h1.title-block-header {
    font-size: 34px;
    margin-bottom: 25px;
  }
  /* TELEFON => H1 NA GÓRZE STRONY CHOWAŁ SIĘ POD STAŁYM MENU I STAŁ Z LEWEJ NAD WYŚRODKOWANYM TEKSTEM */
  @media (max-width: 600px) {
    h1.title-block-header {
      text-align: center;
      margin-top: 50px;
    }
  }
  @media (max-width: 360px) {
    h1.title-block-header {
      margin-top: 90px;
    }
  }
  ${(props: any) => typeof props.paddingTop === 'number' && `padding-top: ${props.paddingTop}px !important;`}
  ${(props: any) => typeof props.paddingBottom === 'number' && `padding-bottom: ${props.paddingBottom}px !important;`}
`;

const TitleBlockIdWrapper = styled.div`
  display: block;
  height: 63px;
  margin-top: -63px;
  visibility: hidden;
  position: absolute;
`;

export default TitleBlock


// WEBPACK FOOTER //
// ./src/layouts/title-block/title-block.tsx